import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslations } from 'next-intl';
import NextImage from 'next/image';
interface PropTypes {
  data: {
    internal_rating: number;
    imdb_rating?: number;
  };
}
function MovieOrTvRating(t0) {
  const $ = _c(17);
  const {
    data
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== t) {
    t1 = t("movie_or_tv_rating.trakio_rating_alt");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <NextImage className="rounded-md mr-2" src="/assets/app/rating-logo.svg" width={113} height={40} alt={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.internal_rating) {
    t3 = data.internal_rating.toFixed(1);
    $[4] = data.internal_rating;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="text-white text-center font-bold text-lg md:text-xl">{t3}/10</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="flex flex-row items-center">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== data.imdb_rating || $[12] !== t) {
    t6 = data.imdb_rating && <div className="flex flex-row items-center ml-10"><NextImage className="rounded-md mr-2" src="/assets/app/imdb-rating-logo.svg" width={50} height={40} alt={t("movie_or_tv_rating.imdb_rating_alt")} /><span className="text-white text-center font-bold text-lg md:text-xl">{data.imdb_rating.toFixed(1)}/10</span></div>;
    $[11] = data.imdb_rating;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex flex-row justify-start items-center mt-8">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default MovieOrTvRating;